/**
 * Game Constants and Configuration
 * Centralized location for all magic numbers and configuration values
 */

// Game display limits
export const GAME_LIMITS = {
  HOMEPAGE_DISPLAY: 15, // Max games to show on homepage sections
  BONUS_GAMES_RANDOM: 10, // Random bonus games selection
  NEW_USER_GAMES_RANDOM: 5 // Random new user games selection
}

// Cache configuration with expiration strategies
export const CACHE_STRATEGIES = {
  bonusGames: { strategy: 'hours', hours: 2 },
  newGames: { strategy: 'end-of-day' },
  newUserGames: { strategy: 'end-of-day' },
  hotPGGames: { strategy: 'end-of-day' },
  popularGames: { strategy: 'hours', hours: 2 },
  'new-games': { strategy: 'end-of-day' }, // Menu version
  'hot-games': { strategy: 'hours', hours: 2 }, // Menu version
  'popular-games': { strategy: 'hours', hours: 2 }, // Menu version
  fishing: { strategy: 'end-of-day' } // Fishing games
}

// Cache keys for different game types
export const CACHE_KEYS = [
  'bonusGames',
  'newGames',
  'newUserGames',
  'hotPGGames',
  'popularGames',
  'new-games',
  'hot-games',
  'popular-games'
]

// Homepage game section types
export const HOMEPAGE_SECTIONS = [
  'bonusGames',
  'newGames',
  'newUserGames',
  'hotPGGames',
  'popularGames'
]

// Menu-specific cache keys
export const MENU_CACHE_KEYS = ['new-games', 'hot-games', 'popular-games']

// Menu title mappings
export const MENU_TITLES = {
  // Categories
  'new-games': 'เกมส์ใหม่',
  'hot-games': 'เกมส์แตกตอนนี้',
  'popular-games': 'เกมส์คนเล่นเยอะ',
  // Game Types
  slots: 'สล็อต',
  baccarat: 'บาคาร่า',
  fishing: 'ยิงปลา',
  casino: 'คาสิโน',
  lottery: 'หวย',
  sport: 'กีฬา'
}

// Component configuration mapping
export const CONTENT_CONFIG = {
  slots: 'ProviderLists',
  baccarat: 'ProviderLists',
  sport: 'ProviderLists',
  lottery: 'ProviderLists'
  // All other keys default to 'GameGridContent'
}

// Random shuffle configuration
export const RANDOM_CONFIG = {
  BONUS_GAMES_START_INDEX: 0,
  BONUS_GAMES_END_INDEX: 10,
  NEW_USER_GAMES_START_INDEX: 10,
  NEW_USER_GAMES_END_INDEX: 15
}

// Loading messages
export const LOADING_MESSAGES = {
  HOMEPAGE: {
    title: 'กำลังโหลดหน้าแรก...',
    subtitle: 'กำลังเตรียมเกมส์สุดพิเศษให้คุณ'
  },
  MENU_CONTENT: {
    title: 'กำลังค้นหาเกมส์ที่ดีที่สุดให้คุณ'
  }
}

// API endpoints (if needed for future expansion)
export const API_ENDPOINTS = {
  HOMEPAGE_DATA: '/internal/common/homepage',
  GAME_PROVIDERS: '/internal/game/provider',
  PROVIDER_GAMES: '/internal/game/lists',
  GAME_LIST_TAB: '/internal/game/list/tab',
  GAME_LOGIN: 'member/gameplay/login'
}

// Error messages
export const ERROR_MESSAGES = {
  INVALID_API_RESPONSE: 'Invalid response format from homepage API',
  CACHE_WRITE_FAILED: 'Failed to write to cache',
  CACHE_READ_FAILED: 'Failed to read from cache',
  GAME_LAUNCH_FAILED: 'เกิดข้อผิดพลาดในการเปิดเกม กรุณาลองใหม่อีกครั้ง'
}

// Default values
export const DEFAULTS = {
  GAME_CATEGORY: 'SLOT',
  GAME_STATUS: 'ACTIVE',
  ONLINE_COUNT_MIN: 100,
  ONLINE_COUNT_MAX: 500,
  CACHE_FALLBACK_HOURS: 24
}

// Validation constants
export const VALIDATION = {
  MIN_GAMES_FOR_RANDOM: 15, // Minimum games needed for random selection
  MAX_CACHE_SIZE_MB: 10, // Maximum cache size in MB
  MAX_CACHE_AGE_DAYS: 7 // Maximum cache age in days
}
